var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "GmapMap",
    {
      ref: "gmap",
      staticClass: "gmap",
      attrs: {
        center: _vm.mapCenter,
        zoom: _vm.mapZoom,
        "map-type-id": _vm.mapType,
        options: _vm.mapOptions
      }
    },
    _vm._l(_vm.mapMarkers, function(m, index) {
      return _c("GmapMarker", {
        key: index,
        attrs: {
          position: m.position,
          icon: m.icon,
          clickable: true,
          draggable: false,
          title: m.title
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }